import { Flex, Text } from "@chakra-ui/react";

export function BankingInformationLine({
    title,
    value,
}: {
    title: string;
    value: string;
}) {
    return (
        <Flex gap={1} justifyContent={"space-between"}>
            <Text color={"black"}>{title}</Text>
            <Text color={"black"}>{value}</Text>
        </Flex>
    );
}
